import styled from 'styled-components'

export const Root = styled.section`
  position: relative;
  color: white;
  font-family: sans-serif;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const Main = styled.div`
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow: auto;
`
